import classNames from 'classnames';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import React from 'react';
import {
    DcMotor01Example,
    DcMotor02Example,
    LedBlockExample,
    MasterBlockExample,
    SountBlockExample,
    ProximitySensorExample,
    LightNTouchSensorBlockExample,
    LightNTouchSensorBlockExample02,
    ExtensionExample,
    RealPythonExample,
    PandasExample,
    ChartExample,
    RobotCarLv1Example,
    RobotCarLv2Example,
    RobotCarLv3Example,
    LightSoundLv1Example,
    LightSoundLv2Example,
    LightSoundLv3Example,
    ScoreLv1Example,
    ScoreLv2Example,
    ScoreLv3Example,
    MoneyLv1Example,
    MoneyLv2Example,
    MoneyLv3Example
} from './pythoncode-example-data';
import styles from './pythoncode-tab.css';
import funcList0ImgSrc from '/src/lib/libraries/extensions/cubroid_dc_motor_1/cubroid_dcmotor_1_icon.svg';
import funcList1ImgSrc from '/src/lib/libraries/extensions/cubroid_dc_motor_1/cubroid_dcmotor_1_icon.svg';
import funcList2ImgSrc from '/src/lib/libraries/extensions/cubroid_led/cubroid_led_icon.svg';
import funcList3ImgSrc from '/src/lib/libraries/extensions/cubroid_master/cubroid_master_icon.svg';
import funcList4ImgSrc from '/src/lib/libraries/extensions/cubroid_sound/cubroid_sound_icon.svg';
import funcList5ImgSrc from '/src/lib/libraries/extensions/cubroid_proximity/cubroid_proximity_icon.svg';
import funcList6ImgSrc from '/src/lib/libraries/extensions/cubroid_lighttouch/cubroid_lighttouch_icon.svg';
import funcList7ImgSrc from '/static/icon/extension_icon.png';


const ViewType = {
    nomal: 0,
    insertBtn: 1
};
const funcList = [
    {
        id: 'funcList-0',
        title: 'DC Motor Block 1',
        src: funcList0ImgSrc,
        li: [
            {
                type: ViewType.nomal,
                text: 'turn_dcmotor1("LEFT")'
            },
            {
                type: ViewType.nomal,
                text: 'turn_dcmotor1("RIGHT")'
            },
            {
                type: ViewType.nomal,
                text: 'turn_dcmotor1("STOP")'
            },
            {
                type: ViewType.nomal,
                text: 'turn_dcmotor1_time("LEFT", 3)'
            },
            {
                // 속도(0~255) — 파이썬은 하드웨어 값 그대로(심화). 블록은 %.
                // ⚠️ 여기 추가하면 pythoncode-tab.jsx 의 CUBROID_PY_BUILTINS 에도 넣어야 색이 붙는다.
                type: ViewType.nomal,
                text: 'set_dcmotor1_speed(200)'
            },
            {
                type: ViewType.insertBtn,
                text: 'example',
                exampleCode: DcMotor01Example
            }
        ]
    },
    {
        id: 'funcList-1',
        title: 'DC Motor Block 2',
        src: funcList1ImgSrc,
        li: [
            {
                type: ViewType.nomal,
                text: 'turn_dcmotor2("LEFT")'
            },
            {
                type: ViewType.nomal,
                text: 'turn_dcmotor2("RIGHT")'
            },
            {
                type: ViewType.nomal,
                text: 'turn_dcmotor2("STOP")'
            },
            {
                type: ViewType.nomal,
                text: 'turn_dcmotor2_time("LEFT", 3)'
            },
            {
                type: ViewType.nomal,
                text: 'set_dcmotor2_speed(200)'
            },
            {
                type: ViewType.insertBtn,
                text: 'example',
                exampleCode: DcMotor02Example
            }
        ]
    },
    {
        id: 'funcList-2',
        title: 'LED Block',
        src: funcList2ImgSrc,
        li: [
            {
                type: ViewType.nomal,
                text: 'display_show("A")'
            },
            {
                type: ViewType.nomal,
                text: 'display_set_pixel("ffffffffffffffff")'
            },
            {
                type: ViewType.nomal,
                text: 'display_clear()'
            },
            // {
            //     type: ViewType.nomal,
            //     text: `1 ~ 9<br />
            //     A ~ Z<br />
            //     text: 'SMILE1<br />
            //     SMILE2<br />
            //     SMILE3<br />
            //     SMILE4<br />
            //     HAPPY<br />
            //     CRY<br />
            //     ANGRY<br />
            //     SAD<br />
            //     SUN<br />
            //     MOON<br />
            //     SQUARE<br />
            //     CIRCLE<br />
            //     TRIANGLE<br />
            //     FLOWER<br />
            //     HEART<br />
            //     8ANGLES<br />
            //     EXCLAMATION<br />
            //     QUESTION<br />
            //     STAR<br />
            //     MINUS<br />
            //     PLUS<br />
            //     MULTIPLY<br />
            //     DIVISION<br />
            //     DURK<br />
            //     NOTE1<br />
            //     NOTE2<br />
            //     O<br />
            //     X<br />
            //     FULL<br />
            //     FORWARD<br />
            //     BACKWARD<br />
            //     RIGHT<br />
            //     LEFT<br />
            //     CLEAR<br />`,
            // },
            {
                type: ViewType.insertBtn,
                text: 'example',
                exampleCode: LedBlockExample
            }
        ]
    },
    {
        id: 'funcList-3',
        title: 'Master Block',
        src: funcList3ImgSrc,
        li: [
            {
                type: ViewType.nomal,
                text: 'turnon_colorlight_show("RED")'
            },
            {
                type: ViewType.nomal,
                text: 'turnon_colorlight("#00ff00")'
            },
            {
                type: ViewType.nomal,
                text: 'turnoff_colorlight()'
            },
            // {
            //     type: ViewType.nomal,
            //     text: `BLACK<br />
            //     WHITE<br />
            //     RED<br />
            //     GREEN<br />
            //     BLUE<br />
            //     YELLOW<br />
            //     TURQUOISE<br />
            //     PURPLISH`,
            // },
            {
                type: ViewType.insertBtn,
                text: 'example',
                exampleCode: MasterBlockExample
            }
        ]
    },
    {
        id: 'funcList-4',
        title: 'Sound Block',
        src: funcList4ImgSrc,
        li: [
            {
                type: ViewType.nomal,
                text: 'play_note("DO_48")'
            },
            {
                type: ViewType.nomal,
                text: 'play_note_time("DO_48", 3)'
            },
            // {
            //     type: ViewType.nomal,
            //     text: `DO<br />
            //     RE<br />
            //     MI<br />
            //     FA<br />
            //     SOL<br />
            //     LA<br />
            //     SI<br />
            //     DO2<br />`,
            // },
            {
                type: ViewType.insertBtn,
                text: 'example',
                exampleCode: SountBlockExample
            }
        ]
    },
    {
        id: 'funcList-5',
        title: 'Proximity Sensor Block',
        src: funcList5ImgSrc,
        li: [
            {
                type: ViewType.nomal,
                text: 'is_obstacle_detected()'
            },
            {
                type: ViewType.insertBtn,
                text: 'example',
                exampleCode: ProximitySensorExample
            }
        ]
    },
    {
        id: 'funcList-6',
        title: 'Light n Touch Sensor Block',
        src: funcList6ImgSrc,
        li: [
            {
                type: ViewType.nomal,
                text: 'get_brigtness()'
            },
            {
                type: ViewType.nomal,
                text: 'is_button_pressed()'
            },
            {
                type: ViewType.insertBtn,
                text: 'example',
                exampleCode: LightNTouchSensorBlockExample
            },
            {
                type: ViewType.insertBtn,
                text: 'example',
                exampleCode: LightNTouchSensorBlockExample02
            }
        ]
    },
    {
        id: 'funcList-7',
        title: 'Extension',
        src: funcList7ImgSrc,
        li: [
            {
                type: ViewType.nomal,
                text: 'sleep(1)'
            },
            {
                type: ViewType.nomal,
                text: 'randint(1, 10)'
            },
            {
                type: ViewType.insertBtn,
                text: 'example',
                exampleCode: ExtensionExample
            }
        ]
    },
    {
        id: 'funcList-smart',
        title: 'Smart Projects · Lv1-3',
        src: funcList0ImgSrc,
        li: [
            {
                type: ViewType.nomal,
                text: 'Grow a project step by step: Lv1 → Lv2 → Lv3.'
            },
            {
                type: ViewType.nomal,
                text: 'Run these with the [ Run ] button (Smart Blocks).'
            },
            {
                type: ViewType.insertBtn,
                text: 'Robot Car · Lv1',
                exampleCode: RobotCarLv1Example
            },
            {
                type: ViewType.insertBtn,
                text: 'Robot Car · Lv2',
                exampleCode: RobotCarLv2Example
            },
            {
                type: ViewType.insertBtn,
                text: 'Robot Car · Lv3',
                exampleCode: RobotCarLv3Example
            },
            {
                type: ViewType.insertBtn,
                text: 'Light & Sound · Lv1',
                exampleCode: LightSoundLv1Example
            },
            {
                type: ViewType.insertBtn,
                text: 'Light & Sound · Lv2',
                exampleCode: LightSoundLv2Example
            },
            {
                type: ViewType.insertBtn,
                text: 'Light & Sound · Lv3',
                exampleCode: LightSoundLv3Example
            }
        ]
    },
    {
        id: 'funcList-data',
        title: 'Data Projects · Lv1-3',
        src: funcList7ImgSrc,
        li: [
            {
                type: ViewType.nomal,
                text: 'Grow a data project: Lv1 → Lv2 → Lv3.'
            },
            {
                type: ViewType.nomal,
                text: 'Run with [ Python 3 ]. Lv2+ chart() needs the Data Chart extension.'
            },
            {
                type: ViewType.insertBtn,
                text: 'Score Analysis · Lv1',
                exampleCode: ScoreLv1Example
            },
            {
                type: ViewType.insertBtn,
                text: 'Score Analysis · Lv2',
                exampleCode: ScoreLv2Example
            },
            {
                type: ViewType.insertBtn,
                text: 'Score Analysis · Lv3',
                exampleCode: ScoreLv3Example
            },
            {
                type: ViewType.insertBtn,
                text: 'My Money · Lv1',
                exampleCode: MoneyLv1Example
            },
            {
                type: ViewType.insertBtn,
                text: 'My Money · Lv2',
                exampleCode: MoneyLv2Example
            },
            {
                type: ViewType.insertBtn,
                text: 'My Money · Lv3',
                exampleCode: MoneyLv3Example
            }
        ]
    },
    {
        id: 'funcList-py3',
        title: 'Python 3 · Data Science',
        src: funcList7ImgSrc,
        li: [
            {
                type: ViewType.nomal,
                text: 'Real CPython 3.14 — [ Python 3 ] button'
            },
            {
                type: ViewType.nomal,
                text: 'import pandas as pd'
            },
            {
                type: ViewType.nomal,
                text: 'chart(labels, values) — draw with Data Chart'
            },
            {
                type: ViewType.insertBtn,
                text: 'Example · Real Python',
                exampleCode: RealPythonExample
            },
            {
                type: ViewType.insertBtn,
                text: 'Example · pandas',
                exampleCode: PandasExample
            },
            {
                type: ViewType.insertBtn,
                text: 'Example · Chart',
                exampleCode: ChartExample
            }
        ]
    }
];

const ItemConponent = (props) => {
    const { data, insertExampleCode } = props;
    if (data?.type === ViewType.nomal) {
        return (
            <div
                className={styles.pcgContent}
                dangerouslySetInnerHTML={{__html: data?.text}}>
            </div>
        );
    } else if (data?.type === ViewType.insertBtn) {
        return (
            <div className={styles.pcgContent}>
                <button
                    className={`${styles.pcgBtn} ${styles.primary}`}
                    onClick={() => {insertExampleCode(data?.exampleCode)}}>
                        {data?.text}
                </button>
            </div>
        );
    }
}

// class PythoncodeTabGuideComponent extends React.Component {
//     constructor (props) {
//         super(props);
//         bindAll(this, []);
//     }

//     render () {
//         const {
//             insertExampleCode,
//         } = this.props;

//         return (
//             <div className={styles.pcgBox}>
//                 <div className={styles.pcgInBox}>
//                 {
//                     funcList.map((data, idx) => {
//                         return (
//                             <div className={styles.pcgContainer} key={idx}>
//                                 <div className={styles.pcgTitle}>{data?.title}</div>
//                                 {
//                                     data?.li.map((liData, liIdx) => {
//                                         return (
//                                             <ItemConponent key={liIdx} data={liData} insertExampleCode={insertExampleCode} />
//                                         )
//                                     })
//                                 }
//                             </div>
//                         )
//                     })
//                 }
//                 </div>
//             </div>
//         );
//     }
// };

class PythoncodeTabGuideComponent extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleScrollToItem',
            'updateEmptyBoxHeight'
        ]);
        this.pcgInBox_2_2_Ref = React.createRef();
        this.pcgBox_2_Ref = React.createRef();
        this.emptyBoxRef = React.createRef();
    }

    componentDidMount () {
        this.updateEmptyBoxHeight();
        window.addEventListener('resize', this.updateEmptyBoxHeight);
    }

    componentWillUnmount () {
        window.removeEventListener('resize', this.updateEmptyBoxHeight);
    }

    updateEmptyBoxHeight () {
        const pcgBox_2_Element = this.pcgBox_2_Ref.current;
        const emptyBoxElement = this.emptyBoxRef.current;
        
        if (pcgBox_2_Element && emptyBoxElement) {
            const height = pcgBox_2_Element.clientHeight;
            emptyBoxElement.style.paddingBottom = `${height}px`;
        }
    }

    handleScrollToItem (dataId) {
        const targetElement = document.getElementById(dataId);
        const containerElement = this.pcgInBox_2_2_Ref.current;
        
        if (targetElement && containerElement) {
            const targetOffsetTop = targetElement.offsetTop;
            containerElement.scrollTo({
                top: targetOffsetTop,
                behavior: 'smooth'
            });
        }
    }

    render () {
        const {
            insertExampleCode
        } = this.props;

        return (
            <div
                className={styles.pcgBox_2}
                ref={this.pcgBox_2_Ref}
            >
                <div className={styles.pcgBoxContainer_2}>

                    <div className={styles.pcgInBox_2_1}>
                        {
                            funcList.map((data, idx) => (
                                <div
                                    key={idx}
                                    className={styles.pcgInBox_2_1_item}
                                    onClick={() => {
                                        this.handleScrollToItem(data.id);
                                    }}
                                >
                                    <div className={styles.pcgInBox_2_1_item_img}>
                                        <img src={data.src} />
                                    </div>
                                    <div className={styles.pcgInBox_2_1_item_title}>
                                        {data?.title}
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div
                        className={styles.pcgInBox_2_2}
                        ref={this.pcgInBox_2_2_Ref}
                    >
                        {
                            funcList.map((data, idx) => (
                                <div
                                    id={data.id}
                                    className={styles.pcgContainer}
                                    key={idx}
                                >
                                    <div className={styles.pcgTitle}>{data?.title}</div>
                                    {
                                        data?.li.map((liData, liIdx) => (
                                            <ItemConponent
                                                key={liIdx}
                                                data={liData}
                                                insertExampleCode={insertExampleCode}
                                            />
                                        ))
                                    }
                                </div>
                            ))
                        }
                        <div
                            id="empty_box"
                            className={styles.pcgContainer}
                            ref={this.emptyBoxRef}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
    
PythoncodeTabGuideComponent.propTypes = {
    insertExampleCode: PropTypes.func
};

export default PythoncodeTabGuideComponent;
